
/* START_TEMPLATE */
define('hbs!app/templates/_applePay',['hbs','Handlebars'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, lambda=this.lambda, escapeExpression=this.escapeExpression;
  return "<div class=\"at-payment-integration-container\" style=\"display: none;\">\n    <div class=\"at-apple-pay-button at-apple-pay-button-logo\" title=\""
    + escapeExpression(lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.resources : depth0)) != null ? stack1.PrimaryResources : stack1)) != null ? stack1.ApplePay : stack1), depth0))
    + "\"></div>\n    <p>"
    + escapeExpression(lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.resources : depth0)) != null ? stack1.PrimaryResources : stack1)) != null ? stack1.AuthorizedThroughApplePay : stack1), depth0))
    + "</p>\n    <div>"
    + escapeExpression(lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.resources : depth0)) != null ? stack1.PrimaryResources : stack1)) != null ? stack1.ContributionAmount : stack1), depth0))
    + ": <b class=\"apple_pay_amount\"></b></div>\n    <div>"
    + escapeExpression(lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.resources : depth0)) != null ? stack1.PrimaryResources : stack1)) != null ? stack1.CardInformation : stack1), depth0))
    + ": <b class=\"apple_pay_card_info\"></b></div>\n</div>\n<label class=\"apple-pay-label\">\n    <input type=\"hidden\" name=\"paymentResponseDetails\" class=\"apple_pay_payment_details\" value=\"\" />\n</label>";
}});
Handlebars.registerPartial('app/templates/_applePay', t);
Handlebars.registerPartial('./_applePay', t);
return t;
});
/* END_TEMPLATE */
;
